export const countryFromHost = (host = window.location.host) => {
    const envMatch = window.COUNTRY?.toLowerCase().match(/(ca|be|es|lu|br|co)/)
    const match = host.toLowerCase().match(/(ca|be|es|lu|br|co)\.(parkindigo|testindigo)\.com/)

    return (match && match[1]) || (envMatch && envMatch[0]) || 'ca'
}

export const countriesFromHost = () => {
    const country = countryFromHost()

    switch (country) {
        case 'fr':
        case 'be':
        case 'lu':
        case 'es':
            return 'FR,BE,LU,ES'
        case 'ca':
            return 'CA'
        case 'br':
        case 'br-neo':
            return 'BR'
        case 'co':
            return 'CO'
        default:
            return 'UK'
    }
}

export const defaultLocaleFromHost = () => {
    const country = countryFromHost()

    switch (country) {
        case 'ca':
            return 'en-ca'
        case 'be':
            return 'nl-be'
        case 'es':
        case 'co':
            return 'es-co'
        case 'lu':
            return 'fr-fr'
        case 'br':
        case 'pt':
            return 'pt-br'
        default:
            return 'en'
    }
}

export const languageFromPath = (pathname = window.location.pathname) => {
    const match = pathname.toLowerCase().match(/\/([a-z]{2})(?=\/|$)/)

    const country = (match && match[1]) || 'en'

    switch (country) {
        case 'en':
            return 'en-ca'
        case 'be':
            return 'nl-be'
        case 'es':
        case 'co':
            return 'es-co'
        case 'lu':
        case 'fr':
            return 'fr-ca'
        case 'br':
        case 'pt':
            return 'pt-br'
        default:
            return 'en-ca'
    }
}

export const isHostCanada = countryFromHost() === 'ca'

export const isBrazilNeo = window.COUNTRY.toUpperCase() === 'BR-NEO'

export const getActiveLocale = languages => {
    // check if WP has returned list of languages
    if (Object.keys(languages).length) {
        // and return locale from the one that is 'current: true'
        return Object.values(languages)
            .find(lang => lang.current)
            .locale.toLowerCase()
    } else {
        // otherwise return a predefined default locale
        return defaultLocaleFromHost()
    }
}

export const getDefaultCoordinates = (country = countryFromHost()) =>
    ({
        uk: {
            // London
            lat: 51.51509656653488,
            lng: -0.08552930126950287,
        },
        ca: {
            // Ottawa
            lat: 45.421983,
            lng: -75.695691,
        },
        be: {
            // Brussels
            lat: 50.847722,
            lng: 4.351125,
        },
        es: {
            // Madrid
            lat: 40.416664,
            lng: -3.70375,
        },
        cz: {
            // Prague
            lat: 50.074801,
            lng: 14.437167,
        },
        sk: {
            // Bratislava
            lat: 48.148386,
            lng: 17.107148,
        },
        lu: {
            // Luxembourg
            lat: 49.6110312,
            lng: 6.1293533,
        },
        de: {
            // Berlin
            lat: 52.519921,
            lng: 13.404746,
        },
        us: {
            // Chicago
            lat: 41.8781,
            lng: -87.6298,
        },
        br: {
            // Rio de Janeiro city center
            lat: -22.906811902384387,
            lng: -43.18352586316361,
        },
        co: {
            // Bogota city center
            lat: 4.711111,
            lng: -74.072222,
        },

    }[country]) // prettier-ignore
